import { render, staticRenderFns } from "./cakeShaped.vue?vue&type=template&id=9b6f6ac4&scoped=true"
import script from "./cakeShaped.vue?vue&type=script&lang=js"
export * from "./cakeShaped.vue?vue&type=script&lang=js"
import style0 from "./cakeShaped.vue?vue&type=style&index=0&id=9b6f6ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6f6ac4",
  null
  
)

export default component.exports